// extracted by mini-css-extract-plugin
export default {"section-title":"g__section-title--pZ2Vb","detail-row":"g__detail-row--QkvHQ","comment-section":"g__comment-section--wcUIg","up-down-buttons":"g__up-down-buttons--sETs5"};